// extracted by mini-css-extract-plugin
module.exports = {"container":"TafsirEndOfScrollingActions_container__tcWLj"};